import { IAction } from '~/src/store';

import { EPaymentActions } from './index';

export type TToggleIsShowSpecOffer = IAction<EPaymentActions.TOGGLE_IS_SHOW_SPECOFFER, boolean>

const toggleIsShowSpecOffer = (status: boolean): TToggleIsShowSpecOffer => ({
    type: EPaymentActions.TOGGLE_IS_SHOW_SPECOFFER,
    payload: status,
});

export default toggleIsShowSpecOffer;
